// src/component/VehicleFormModal.jsx
import React from 'react';
import { FaUpload } from "react-icons/fa";

export default function VehicleFormModal({
    formData,
    setFormData,
    isEditMode,
    onClose,
    onSubmit
}) {
    const handleInput = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFile = (e) => {
        const { name, files } = e.target;
        setFormData(prev => ({ ...prev, [name]: files?.[0] || null }));
    };

    // File types allowed
    const acceptTypes = '.jpg,.jpeg,.png,.pdf';

    return (
        <>
            <div className="modal show fade d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <form onSubmit={onSubmit}>
                            <div className="modal-header">
                                <h5 className="modal-title">{isEditMode ? 'Edit' : 'Add'} Vehicle</h5>
                                <button type="button" className="btn-close" onClick={onClose} />
                            </div>

                            <div className="modal-body">
                                <div className="row g-3">
                                    {/* Vehicle Number */}
                                    <div className="col-md-4">
                                        <label className="form-label">Vehicle Number</label>
                                        <input
                                            className="form-control"
                                            name="number"
                                            value={formData.number || ''}
                                            onChange={handleInput}
                                            required
                                            disabled={isEditMode}
                                        />
                                    </div>

                                    {/* Tax Expiry */}
                                    <div className="col-md-4">
                                        <label className="form-label">Tax Expiry</label>
                                        <div className="d-flex align-items-center">
                                            <input
                                                className="form-control"
                                                type="date"
                                                name="taxExpiry"
                                                value={formData.taxExpiry || ''}
                                                onChange={handleInput}
                                                required
                                            />
                                            <label htmlFor="taxFile" className="ms-2" style={{ cursor: "pointer" }}>
                                                <FaUpload />
                                            </label>
                                            <input
                                                id="taxFile"
                                                type="file"
                                                name="taxFile"   // ✅ matches backend key
                                                accept={acceptTypes}
                                                onChange={handleFile}
                                                hidden
                                            />
                                        </div>
                                    </div>

                                    {/* Fitness Expiry */}
                                    <div className="col-md-4">
                                        <label className="form-label">Fitness Expiry</label>
                                        <div className="d-flex align-items-center">
                                            <input
                                                className="form-control"
                                                type="date"
                                                name="fitnessExpiry"
                                                value={formData.fitnessExpiry || ''}
                                                onChange={handleInput}
                                                required
                                            />
                                            <label htmlFor="fitnessFile" className="ms-2" style={{ cursor: "pointer" }}>
                                                <FaUpload />
                                            </label>
                                            <input
                                                id="fitnessFile"
                                                type="file"
                                                name="fitnessFile"   // ✅ matches backend key
                                                accept={acceptTypes}
                                                onChange={handleFile}
                                                hidden
                                            />
                                        </div>
                                    </div>

                                    {/* Insurance Expiry */}
                                    <div className="col-md-4">
                                        <label className="form-label">Insurance Expiry</label>
                                        <div className="d-flex align-items-center">
                                            <input
                                                className="form-control"
                                                type="date"
                                                name="insuranceExpiry"
                                                value={formData.insuranceExpiry || ''}
                                                onChange={handleInput}
                                                required
                                            />
                                            <label htmlFor="insuranceFile" className="ms-2" style={{ cursor: "pointer" }}>
                                                <FaUpload />
                                            </label>
                                            <input
                                                id="insuranceFile"
                                                type="file"
                                                name="insuranceFile"   // ✅ matches backend key
                                                accept={acceptTypes}
                                                onChange={handleFile}
                                                hidden
                                            />
                                        </div>
                                    </div>

                                    {/* Pollution Expiry */}
                                    <div className="col-md-4">
                                        <label className="form-label">Pollution Expiry</label>
                                        <div className="d-flex align-items-center">
                                            <input
                                                className="form-control"
                                                type="date"
                                                name="pollutionExpiry"
                                                value={formData.pollutionExpiry || ''}
                                                onChange={handleInput}
                                                required
                                            />
                                            <label htmlFor="pollutionFile" className="ms-2" style={{ cursor: "pointer" }}>
                                                <FaUpload />
                                            </label>
                                            <input
                                                id="pollutionFile"
                                                type="file"
                                                name="pollutionFile"   // ✅ matches backend key
                                                accept={acceptTypes}
                                                onChange={handleFile}
                                                hidden
                                            />
                                        </div>
                                    </div>

                                    {/* Permit Expiry */}
                                    <div className="col-md-4">
                                        <label className="form-label">Permit Expiry</label>
                                        <div className="d-flex align-items-center">
                                            <input
                                                className="form-control"
                                                type="date"
                                                name="permitExpiry"
                                                value={formData.permitExpiry || ''}
                                                onChange={handleInput}
                                                required
                                            />
                                            <label htmlFor="permitFile" className="ms-2" style={{ cursor: "pointer" }}>
                                                <FaUpload />
                                            </label>
                                            <input
                                                id="permitFile"
                                                type="file"
                                                name="permitFile"   // ✅ matches backend key
                                                accept={acceptTypes}
                                                onChange={handleFile}
                                                hidden
                                            />
                                        </div>
                                    </div>

                                    {/* Owner + Driver */}
                                    <div className="col-md-6">
                                        <label className="form-label">Owner Name (optional)</label>
                                        <input
                                            className="form-control"
                                            name="ownerName"
                                            value={formData.ownerName || ''}
                                            onChange={handleInput}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label">Driver Phone</label>
                                        <input
                                            className="form-control"
                                            type="tel"
                                            name="driverPhone"
                                            pattern="[0-9]{10}"
                                            minLength={10}
                                            maxLength={10}
                                            value={formData.driverPhone || ''}
                                            onChange={handleInput}
                                            required
                                        />
                                    </div>

                                    {/* File Preview */}
                                    <div className="col-12">
                                        <small className="text-muted">
                                            {formData.taxFile?.name && `Tax: ${formData.taxFile.name} · `}
                                            {formData.fitnessFile?.name && `Fitness: ${formData.fitnessFile.name} · `}
                                            {formData.insuranceFile?.name && `Insurance: ${formData.insuranceFile.name} · `}
                                            {formData.pollutionFile?.name && `Pollution: ${formData.pollutionFile.name} · `}
                                            {formData.permitFile?.name && `Permit: ${formData.permitFile.name}`}
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
                                <button type="submit" className="btn btn-primary">
                                    {isEditMode ? 'Update' : 'Save'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" />
        </>
    );
}
